import { useQueryClient } from 'react-query';

// Import types
import type { CalculatedPriceProduct } from 'types/api/packetsSubscription';

// Import hooks
import { useAppSelector } from 'store/hooks';

export const useCalculatedPrice = (): CalculatedPriceProduct[] => {
	const queryClient = useQueryClient();
	const token = useAppSelector(({ subscriber }) => subscriber.token);

	const calculated = queryClient.getQueryData<CalculatedPriceProduct[]>(['configurator_packets_price', token]) ?? [];

	return calculated;
};
